module.exports = __webpack_public_path__ + "static/media/ARIVA_WHITE.e4fd0143.png";